module.exports = __webpack_public_path__ + "static/media/eventpop_purra1500.c460004c.jpg";